// extracted by extract-css-chunks-webpack-plugin
module.exports = {"creditBreakdownTable":"CreditBreakdownTable-8753350e3555e195","heading":"CreditBreakdownTable-5d0200ccd2946b33","items":"CreditBreakdownTable-8f26866877d24908"};